import React, { useState } from 'react'
import { useRequest } from '../utils/hooks'
import { Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import DialogBusinessComponent from '../components/DialogBusinessComponent'

const INITIAL_STATE_FORM = {
    cnpj: '',
    nome: '',
    email: '',
    telefone: '',
    whatsapp: '',
    facebook: '',
    instagram: '',
    site: '',
    endereco: '',
    bairro: '',
    cidade: '',
    segmento: '',
    atendendoComo: '',
    negocio: true,
    aceito: false,
}

const DialogBusiness = ({ dialog, setDialog }) => {
  const [formState, setFormState] = useState(INITIAL_STATE_FORM)

  const [snackbarOpen, setSnackbarOpen] = useState({
    open: false,
    success: true,
    message: '',
  })

  const [
    ,
    statusRequestCreateEstabelecimento,
    createEstabelecimento,
  ] = useRequest(
    {},
    {
      url: 'estabelecimentos',
      method: 'post',
      data: formState,
    },
    null,
    {
      onComplete: () => {
        setSnackbarOpen({
          open: true,
          success: true,
          message:
            'Obrigado por cadastrar seu negócio! Em breve o cadastro será ativado. Você ajudou a construir o Bem Aqui =)',
        })
        setDialog({ open: false, data: null })
        setFormState(INITIAL_STATE_FORM)
      },
    }
  )

  const handleCreateEstabelecimento = () => {
    let field = ''
    if (!formState.cidade) {
      field = 'Cidade'
    }
    if (!formState.bairro) {
      field = 'Bairro'
    }
    if (!formState.nome) {
      field = 'Nome'
    }
    if (!formState.telefone) {
      field = 'Telefone'
    }
    if (!formState.cnpj) {
      field = 'CNPJ'
    }
    if (!formState.email) {
      field = 'E-mail'
    }
    if (!formState.endereco) {
      field = 'Endereço'
    }
    if (!formState.segmento) {
      field = 'Segmento'
    }
    if (!formState.atendendoComo) {
      field = 'Como está atendendo?'
    }
    if (!formState.aceito) {
      field = 'Termo'
    }
    if (field) {

      if (field === 'Termo') {
        setSnackbarOpen({
          open: true,
          success: false,
          message: `Você precisa ler e aceitar os termos de uso para cadastrar seu estabelecimento.`,
        })
      } else {
        setSnackbarOpen({
          open: true,
          success: false,
          message: `Por favor, preencha o campo "${field}".`,
        })
      }
    } else {
      createEstabelecimento()
    }
  }

  return (
    <>
      <DialogBusinessComponent
        dialog={dialog}
        setDialog={setDialog}
        formState={formState}
        setFormState={setFormState}
        create={handleCreateEstabelecimento}
        statusRequestCreateEstabelecimento={statusRequestCreateEstabelecimento}
      />
      <Snackbar
        open={snackbarOpen.open}
        autoHideDuration={120000}
        onClose={() =>
          setSnackbarOpen({ ...snackbarOpen, open: false, message: '' })
        }
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert
          elevation={6}
          variant='filled'
          severity={snackbarOpen.success ? 'success' : 'error'}
        >
          {snackbarOpen.message}
        </MuiAlert>
      </Snackbar>
    </>
  )
}

export default DialogBusiness
